import React, { useState, useEffect } from 'react';
import { THEME } from '../../utils/theme';
import api from '../../utils/api';
import Spinner from '../ui/Spinner';
import Badge from '../ui/Badge';

const RatingComparisonModal = ({ onClose }) => {
  const [comparisons, setComparisons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/games/rating-comparison').then(data => {
      setComparisons(data.comparisons || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(5,5,10,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(20px) saturate(180%)', WebkitBackdropFilter: 'blur(20px) saturate(180%)' }} onClick={onClose}>
      <div style={{ background: `linear-gradient(145deg, ${THEME.bgElevated}, ${THEME.bgCard})`, borderRadius: '20px', padding: '24px', width: '95%', maxWidth: '550px', maxHeight: '85vh', overflow: 'auto', border: `1px solid ${THEME.border}`, boxShadow: `0 25px 80px ${THEME.shadowHeavy}`, animation: 'scaleIn 0.2s ease' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, color: THEME.text, fontSize: '20px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: '24px' }}>⚔️</span> Rating Comparison
          </h2>
          <button onClick={onClose} style={{ background: THEME.bgHover, border: 'none', borderRadius: '8px', padding: '8px 12px', color: THEME.textMuted, cursor: 'pointer' }}>✕</button>
        </div>
        <p style={{ color: THEME.textMuted, fontSize: '13px', marginBottom: '16px' }}>Games rated by both users • Sorted by disagreement</p>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Spinner /></div>
        ) : comparisons.length === 0 ? (
          <div style={{ textAlign: 'center', color: THEME.textMuted, padding: '40px' }}>No games rated by both users yet</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {comparisons.map(game => (
              <div key={game.id} style={{ padding: '14px', background: THEME.bg, borderRadius: '12px', border: `1px solid ${game.agreement === 'disagree' ? THEME.danger + '40' : game.agreement === 'agree' ? THEME.success + '40' : THEME.border}` }}>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '10px' }}>
                  <img src={game.header_image} alt="" style={{ width: '60px', height: '34px', objectFit: 'cover', borderRadius: '6px' }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ color: THEME.text, fontWeight: '600', fontSize: '13px' }}>{game.name}</div>
                    <div style={{ color: THEME.textMuted, fontSize: '11px' }}>Avg: {game.average}/10 • Diff: {game.rating_diff}</div>
                  </div>
                  <Badge color={game.agreement === 'disagree' ? THEME.danger : game.agreement === 'agree' ? THEME.success : THEME.textMuted} bg={game.agreement === 'disagree' ? `${THEME.danger}20` : game.agreement === 'agree' ? `${THEME.success}20` : THEME.bgElevated}>
                    {game.agreement === 'disagree' ? '😤' : game.agreement === 'agree' ? '🤝' : '😐'} {game.rating_diff.toFixed(1)}
                  </Badge>
                </div>
                {/* Dynamic user ratings */}
                <div style={{ display: 'grid', gridTemplateColumns: `repeat(${Object.keys(game.user_data || {}).length || 2}, 1fr)`, gap: '10px' }}>
                  {game.user_data ? Object.entries(game.user_data).map(([username, userData]) => (
                    <div key={username} style={{ background: `${userData.color || THEME.success}10`, borderRadius: '8px', padding: '8px', border: `1px solid ${userData.color || THEME.success}30` }}>
                      <div style={{ fontSize: '10px', color: userData.color || THEME.success, fontWeight: '600', marginBottom: '2px' }}>{userData.icon || ''} {userData.display_name?.toUpperCase() || username.toUpperCase()}</div>
                      <div style={{ fontSize: '18px', color: userData.color || THEME.success, fontWeight: '700' }}>{userData.rating ?? '—'}/10</div>
                    </div>
                  )) : (
                    <>
                      <div style={{ background: THEME.successLight, borderRadius: '8px', padding: '8px', border: `1px solid ${THEME.omegaBorder}` }}>
                        <div style={{ fontSize: '10px', color: THEME.omega, fontWeight: '600', marginBottom: '2px' }}>OMEGA</div>
                        <div style={{ fontSize: '18px', color: THEME.omega, fontWeight: '700' }}>{game.omega_rating}/10</div>
                      </div>
                      <div style={{ background: THEME.infoLight, borderRadius: '8px', padding: '8px', border: `1px solid ${THEME.supeBorder}` }}>
                        <div style={{ fontSize: '10px', color: THEME.supe, fontWeight: '600', marginBottom: '2px' }}>SUPE</div>
                        <div style={{ fontSize: '18px', color: THEME.supe, fontWeight: '700' }}>{game.supe_rating}/10</div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RatingComparisonModal;
